export const site = {
  name: 'Limosys LLC',
  domain: 'limosys.com',
  url: 'https://limosys.com',
  tagline: 'Your one-stop-shop for the transportation industry',
  description:
    'Livery and limo dispatch software for black-car operators. Trusted for over 30 years — reservations, auto-dispatch, driver and passenger apps, from reservation to completion.',
  founded: 1990,
  address: {
    company: 'Limosys LLC',
    street: '180 Sylvan Avenue',
    city: 'Englewood Cliffs, NJ 07632',
  },
  contact: {
    phone: '(212) 222-4433',
    tollFree: '(855) LIMOSYS',
    fax: '(844) LIMOSYS',
    email: 'info@limosys.com',
    supportEmail: 'support@limosys.com',
    jobsEmail: 'jobs@limosys.com',
    hours: 'Available 24/7 for questions and support.',
  },
  links: {
    login: 'https://my.limosys.com',
    getStarted: 'https://qbpay.limosys.com/react/register',
    support: 'https://support.limosys.com',
    tripslink: 'https://tripslink.com/',
    wpay: 'https://wpay.tripslink.com/',
  },
  social: {
    facebook: 'https://www.facebook.com/limosys',
    linkedin: 'https://www.linkedin.com/company/limosys',
    instagram: 'https://www.instagram.com/limosys',
  },
  scheduling: {
    // Cal.com booking link in the form "username/event-type" (or "team/slug").
    // Set this to your real slug after creating the event type in Cal.com and
    // connecting Google Calendar (availability) + Zoom (auto meeting link).
    calLink: 'issac-yehuda-ddboag/30min',
  },
};

export const stats = [
  { value: '30+', label: 'Years in business' },
  { value: '25,000', label: 'Cars in our network' },
  { value: '24/7', label: 'Support & service' },
  { value: '100%', label: 'Customizable platform' },
];

// Navigation. Internal routes use `href`; external links set `external: true`.
export const navItems = [
  { name: 'Home', href: '/' },
  {
    name: 'Platform',
    href: '/platform',
    submenu: [
      { name: 'Platform Overview', href: '/platform' },
      { name: 'Dispatch Software', href: '/dispatch-software' },
      { name: 'Reservations & Booking', href: '/limo-reservation-software' },
      { name: 'Driver App', href: '/driver-app' },
      { name: 'Passenger App', href: '/passenger-app' },
      { name: 'Accounting & Billing', href: '/accounting-billing' },
    ],
  },
  { name: 'Pricing', href: '/pricing' },
  { name: 'Customization', href: '/custom' },
  { name: 'Affiliate Network', href: '/affiliates' },
  {
    name: 'Resources',
    href: '/blog',
    submenu: [
      { name: 'Blog', href: '/blog' },
      { name: 'FAQ', href: '/faq' },
      { name: 'Glossary', href: '/glossary' },
      { name: 'Limo Anywhere Alternative', href: '/limo-anywhere-alternative' },
    ],
  },
  { name: 'Contact', href: '/contact' },
  {
    name: 'TripsLink',
    href: site.links.tripslink,
    external: true,
    submenu: [
      { name: 'Trip Sharing Management', href: site.links.tripslink, external: true },
      { name: 'Payment Solutions', href: site.links.wpay, external: true },
    ],
  },
  { name: 'Support', href: site.links.support, external: true },
];
